exports = module.exports = require("../../../NodeModules/Ljbc/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.Chat .ButtonList .Button {\n    margin-bottom: 5px;\n}\n@media screen and (max-width:660px) {\n.Chat .ButtonList .Button {\n        padding-left: 2px;\n        padding-right: 2px;\n}\n}\n", ""]);

// exports
